import React, { FunctionComponent, SVGProps } from 'react';

import { motion } from 'framer-motion';
import styled, { css, useTheme } from 'styled-components';

import { easeTransition } from '@components/framer';
interface DownloadIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  color?: 'normal' | 'white' | 'orange';
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

const DownloadIcon: FunctionComponent<DownloadIconProps> = ({
  className,
  color,
  onClick,
}) => {
  const theme = useTheme();

  const animation = {
    rest: {
      y: 0,
    },
    hover: {
      y: -3,
      transition: {
        ...easeTransition,
      },
    },
    click: {
      y: 1,
    },
  };

  const getPathColor = (color?: 'normal' | 'white' | 'orange') => {
    if (color === 'white') {
      return theme.colors.white;
    } else if (color === 'orange') {
      return theme.colors.upload;
    } else {
      return theme.colors.primary;
    }
  };

  return (
    <svg
      className={className}
      onClick={(ev) => (onClick ? onClick(ev) : null)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
    >
      <motion.path
        fill={getPathColor(color)}
        variants={animation}
        d="M7.49,1.54V6.75l-.93-.95c-.59-.6-1.54-.59-2.12,0-.3,.3-.44,.7-.44,1.09s.14,.79,.44,1.09l3.51,3.57c.28,.29,.67,.45,1.07,.45s.78-.17,1.07-.46l3.49-3.66c.58-.6,.57-1.58-.03-2.17-.59-.59-1.54-.58-2.12,.03l-.91,.98V1.54c0-.85-.67-1.54-1.51-1.54s-1.51,.68-1.51,1.54h-.01Z"
      />
      <path
        fill={getPathColor(color)}
        d="M17.51,17.51c.3-.3,.49-.71,.49-1.17v-4.15c0-.91-.75-1.66-1.66-1.66s-1.66,.75-1.66,1.66v2.49H3.3v-2.49c0-.91-.75-1.66-1.66-1.66s-1.65,.76-1.65,1.67v4.14c0,.91,.75,1.66,1.66,1.66h14.68c.46,0,.87-.18,1.17-.49Z"
      />
    </svg>
  );
};

export default styled(DownloadIcon)`
  overflow: visible;
  ${(props) =>
    props.onClick
      ? css`
          cursor: pointer;
        `
      : null}
`;
